import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_15: FaireProductEntity = {
  token: "viverano-15",
  type: "product",
  name: "Bunny Baby Knit Blanket & Lovey Gift SET (Organic)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/2809424d79f9a0bd0fbddffd41037c5d1c9d85745b212d7183efadc68ad714c7.png?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 32.5,
  msrpDollars: 55,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_baby-accessories"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
